'use client';

import type { UserDetails } from '@modules/user-profile/user-profile-details-validator';
import { type ReactNode, createContext } from 'react';

// biome-ignore lint/style/noNonNullAssertion: historic
export const UserDetailsContext = createContext<UserDetails>(null!);

export function UserDetailsProvider({
  children,
  userDetails,
}: {
  children: ReactNode;
  userDetails: UserDetails;
}) {
  return <UserDetailsContext.Provider value={userDetails}>{children}</UserDetailsContext.Provider>;
}
